import type { SubmissionType } from '@gobingebox/shared';
import { apiFetch } from '@/lib/api';

export interface DevStatus {
  open: boolean;
  message: string | null;
}

export interface SubmissionInput {
  type: SubmissionType;
  name: string;
  email: string;
  title: string;
  details: string;
  links?: string;
}

export const devApi = {
  status: () => apiFetch<DevStatus>('/dev/status'),
  submit: (input: SubmissionInput) =>
    apiFetch<{ ok: boolean }>('/dev/submissions', { method: 'POST', body: JSON.stringify(input) }),
};
